<template>
  <div class="md-layout-item md-size-100">
    <modal v-if="showModal" @close="modalHide">
      <template slot="header">
        <h4 class="modal-title">{{ $t("add_sensor") }}</h4>
        <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="modalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <md-card>
          <md-card-header
              class="md-card-header-icon md-card-header-green"
          >
            <div class="card-icon">
              <md-icon>settings_remote</md-icon>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout-item md-size-100">
              <form ref="form" id="sensorForm">
                <form-builder
                    ref="formulario"
                    @on-validated="onFormValidated"
                    :value="this.item"
                    :model="datosFormulario"
                    :schema="this.formData"
                >
                </form-builder>
              </form>
            </div>
          </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button class="md-danger md-simple" @click="modalHide">{{
            $t("cancel")
          }}
        </md-button>
        <md-button @click="submit()" class="md-success">{{
            $t("save")
          }}
        </md-button>
      </template>
    </modal>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>settings_remote</md-icon>
        </div>
        <h4 class="title">{{ $t(tableTitle) }}</h4>
        <md-button
          v-if="permissionsAdminCentro"
            class="md-primary pull-right"
            @click="openModal(null)"
        >{{ $t("add_sensor") }}
        </md-button
        >
      </md-card-header>
      <md-card-content>
        <md-table table-header-color="green">
          <md-table-row>
            <md-table-head>ID</md-table-head>
            <md-table-head>{{ $t("status") }}</md-table-head>
            <md-table-head>{{ $t("battery") }}</md-table-head>
            <md-table-head>{{ $t("signal") }}</md-table-head>
            <md-table-head>{{ $t("calibracion") }}</md-table-head>
            <md-table-head>{{ $t("code") }}</md-table-head>
            <md-table-head>{{ $t("patient") }}</md-table-head>
            <md-table-head>{{
                $t("activation_date")
              }}
            </md-table-head>
            <md-table-head v-if="permissionsAdminCentro"></md-table-head>
          </md-table-row>
          <md-table-row
              v-for="(data, i) in response.lista"
              :key="i"
              slot="md-table-row"
          >
            <md-table-cell>{{ data.id }}</md-table-cell>

            <md-table-cell v-if="estado(data) == 0">
              <md-icon class="text-black">lens</md-icon>
            </md-table-cell>
            <md-table-cell v-else-if="estado(data) == 1">
              <md-icon class="text-success">lens</md-icon>
            </md-table-cell>

            <md-table-cell>
              <img
                  :src="bateria(data)"
                  style="height: 20px;width:auto;"
              />
            </md-table-cell>

            <md-table-cell>
              <img
                  :src="potencia(data)"
                  style="height: 20px;width:auto;"
              />
            </md-table-cell>
            <md-table-cell>
              {{ data.capacidad }}
            </md-table-cell>

            <md-table-cell>{{ data.codigo }}</md-table-cell>
            <md-table-cell>
                            <span v-if="data.paciente">
                                {{ data.paciente.nombre }}
                                {{ data.paciente.apellidos }}
                            </span>
            </md-table-cell>
            <md-table-cell>{{
                data.fecha_activacion
              }}
            </md-table-cell>
            <md-table-cell class="text-right" v-if="permissionsAdminCentro">
              <md-button
                  v-if="!data.paciente"
                  class="md-just-icon md-danger"
                  @click="deleteItem(data)"
              >
                <md-icon>close</md-icon>
                <md-tooltip md-direction="top">{{
                    $t("delete")
                  }}
                </md-tooltip>
              </md-button>
              <md-button
                  v-if="data.paciente"
                  class="md-just-icon md-success"
                  @click="deleteItem(data)"
              >
                <md-icon>power_off</md-icon>
                <md-tooltip md-direction="top">{{
                    $t("unlink")
                  }}
                </md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>

      <md-card-actions>
        <div class="md-layout md-alignment-bottom-left">
          <div class="md-layout-item">
            <md-icon class="text-success">lens</md-icon>
            {{ $t("asignado") }}
            <span style="width:20px;display: inline-block"></span>
            <md-icon class="text-black">lens</md-icon>
            {{ $t("not_assigned") }}
          </div>
        </div>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
let BACKEND_API = process.env.VUE_APP_BACKEND_API;
import {authHeader} from "../../helpers/auth-header";
import {handleResponse} from "../../helpers/handle-response";
import Modal from "../Modal";
import formBuilder from "../../formBuilder";
import { EventBus } from '../../helpers/EventBus';

//bateria
import cbat0 from "../../assets/img/cm bat0.png";
import cbat1 from "../../assets/img/cm bat1.png";
import cbat2 from "../../assets/img/cm bat2.png";
import cbat3 from "../../assets/img/cm bat3.png";
import cbat_noinfo from "../../assets/img/cm bat int.png";

//potencia
import cpot0 from "../../assets/img/cm nnet.png";
import cpot1 from "../../assets/img/cm red1.png";
import cpot2 from "../../assets/img/cm red2.png";
import cpot3 from "../../assets/img/cm red3.png";
import cpot4 from "../../assets/img/cm red4.png";

export default {
  name: "sensors_list",
  components: {Modal, formBuilder},
  mounted() {
    this.fetchData();
    EventBus.$on('cambio-centro', this.fetchData);
  },
  data() {
    return {
      permissionsAdminCentro: false,
      formValidated: null,
      body: {},
      id: null,
      item: null,
      itemList: [],
      formData: [],
      showModal: false,
      isLoading: false,
      response: {},
      datosFormulario: {},
      tableTitle: "sensors_management"
    };
  },
  created() {
    this.setPermissions();
  },
  methods: {
     setPermissions() {
      let user = JSON.parse(localStorage.getItem("instantcare_user"));
      if (user.roles.includes("ROLE_CENTRO")) {
        this.permissionsAppQR = false;
        this.permissionsAdminCentro = true;
        this.permissionsAdminCadena = false;
      }
      if (user.roles.includes("ROLE_ENFERMERA")) {
        this.permissionsAppQR = true;
        this.permissionsAdminCentro = false;
        this.permissionsAdminCadena = false;
      }
    },
    bateria: function (data) {
      let vcc = data.bateria;

      let endTime = this.$root.$moment();
      let startTime = this.$root.$moment(
          data.lastTimeOnline,
          "DD/MM/YYYY hh:mm"
      );
      var duration = this.$root.$moment.duration(
          endTime.diff(startTime)
      );
      var min = duration.asMinutes();
      if (!data.encendido || min > 5) {
        return cbat_noinfo;
      }
      if (vcc <= 26) {
        return cbat0;
      }
      if (vcc > 26 && vcc <= 27) {
        return cbat1;
      }
      if (vcc > 27 && vcc <= 28) {
        return cbat2;
      }
      if (vcc > 28) {
        return cbat3;
      }
    },
    potencia: function (data) {
      let pot = data.cobertura;
      let endTime = this.$root.$moment();
      let startTime = this.$root.$moment(
          data.lastTimeOnline,
          "DD/MM/YYYY hh:mm"
      );
      var duration = this.$root.$moment.duration(
          endTime.diff(startTime)
      );
      var min = duration.asMinutes();
      if (!data.encendido || min > 5) {
        return cpot0;
      }

      if (pot === 0) {
        return cpot0;
      }
      if (pot > 0 && pot <= 65) {
        return cpot1;
      }
      if (pot > 65 && pot <= 75) {
        return cpot2;
      }
      if (pot > 75 && pot <= 85) {
        return cpot3;
      }
      if (pot > 85) {
        return cpot4;
      }
    },
    estado: function (data) {
      let status = 0;
      if (data.paciente) {
        status = 1;
      }
      return status;
    },
    destroy() {
      this.formValidated = null;
      this.body = {};
      this.id = null;
      this.item = null;
      this.itemList = [];
      this.formData = [];
      this.response = {};
      this.datosFormulario = {};
    },
    onFormValidated(model) {
      this.datosFormulario = {...this.datosFormulario, ...model};
    },
    submit() {
      this.$refs["formulario"].validate().then(res => {
        if (res) {
          if (!this.item) {
            this.new(this.datosFormulario);
          } else {
            this.edit(this.datosFormulario);
          }
          this.modalHide();
        }
      });
    },
    edit(data) {
      let self = this;
      fetch(`${BACKEND_API}/api/sensores/edit/` + data.id, {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data)
      })
          .then(handleResponse)
          .then(response => {
            self.$notify({
              message: self.$root.$t("sensor_updated_successfully"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
            this.fetchData();
          });
    },
    new(data) {
      let self = this;
      this.id = null;
      fetch(`${BACKEND_API}/api/sensores/new`, {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data)
      })
          .then(handleResponse)
          .then(response => {
            self.$notify({
              message: self.$root.$t("sensor_created_successfully"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
            this.fetchData();
          });
    },
    formConfig() {
      fetch(`${BACKEND_API}/api/sensores/prepare`, {
        method: "GET",
        headers: authHeader()
      })
          .then(response => response.json())
          .then(data => (this.formData = data[1]));
    },
    openModal(id) {
      this.id = id;
      this.item = this.itemList[id];
      this.datosFormulario = {...{}, ...this.item};
      this.formConfig();
      this.showModal = true;
    },
    modalHide() {
      this.showModal = false;
    },
    deleteItem(data) {
      let self = this;
      this.$swal({
        title: this.$root.$t("are_you_sure"),
        text: this.$root.$t("you_cannot_revert_the_operation"),
        type: "warning",
        showCancelButton: true,
        closeOnClickOutside: false,
        confirmButtonText: this.$root.$t("yes"),
        cancelButtonText: this.$root.$t("no"),
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          fetch(`${BACKEND_API}/api/sensores/baja/` + data.id, {
            method: "GET",
            headers: authHeader()
          })
              .then(handleResponse)
              .then(response => {
                self.$notify({
                  message: self.$root.$t(
                      "sensor_deleted_successfully"
                  ),
                  icon: "add_alert",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success"
                });

                this.fetchData();
              });
        }
      });
    },
    fetchData() {
      let self = this;

      let url = `${BACKEND_API}/api/sensores/list`;
      let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
      if (currentCentro) {
        url = `${BACKEND_API}/api/sensores/list?idCentro=${currentCentro.id}`;
      }

      fetch(url, {
        method: "GET",
        headers: authHeader()
      })
          .then(handleResponse)
          .then(response => {
            self.response = response;
            this.itemList = response.lista;
            self.isLoading = false;
          });
    }
  }
};
</script>
<style lang="scss" scoped>
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table-row .md-table-cell:last-child {
  text-align: right;
}

.md-table-cell-container .md-button:not(:first-child) {
  margin-left: 3px;
  margin-right: 3px;
}

.md-table-cell-container .md-button:not(:last-child) {
  margin-left: 3px;
  margin-right: 3px;
}

.text-green {
  color: #45a54e !important;
}
</style>
